import { createContext, useContext } from 'react';

export interface SidePanelContextValue {
  /** 0 = bottom panel. */
  depth: number;
  close: () => void;
}

export const SidePanelContext = createContext<SidePanelContextValue | null>(null);

/** Inside a side panel: its depth and a `close()` for its own buttons. */
export function useSidePanelContext(): SidePanelContextValue {
  const value = useContext(SidePanelContext);
  if (!value) throw new Error('useSidePanelContext() must be used inside a SidePanel.');
  return value;
}
